import { defineMessages } from 'react-intl';

export const trackingMessages = defineMessages({
  completed: { id: 'tracking.completed' },
  congratulations: { id: 'tracking.congratulations' },
  congratulationsHotspots: { id: 'tracking.congratulations_hotspots' },
  congratulationsSequence: { id: 'tracking.congratulations_sequence' },
  congratulationsSlides: { id: 'tracking.congratulations_slides' },
  congratulationsTabs: { id: 'tracking.congratulations_tabs' },
  hotspots: { id: 'tracking.hotspots' },
  item: { id: 'tracking.item' },
  mandatory: { id: 'tracking.mandatory' },
  min: { id: 'tracking.min' },
  optional: { id: 'tracking.optional' },
  progress: { id: 'tracking.progress' },
  resetProgressConfirmText: {
    id: 'tracking.reset_progress_confirm_text',
  },
  resetProgressDescription: {
    id: 'tracking.reset_progress_description',
  },
  resetProgressTitle: { id: 'tracking.reset_progress_title' },
  sec: { id: 'tracking.sec' },
  slides: { id: 'tracking.slides' },
  steps: { id: 'tracking.steps' },
  tabs: { id: 'tracking.tabs' },
  untilCompleted: { id: 'tracking.until_completed' },
  xApiBaseUri: { id: 'tracking.xapi_base_uri' },
  passed: { id: 'tracking.passed' },
  notPassed: { id: 'tracking.not_passed' },
  notStarted: { id: 'tracking.not_started' },
});
